import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import {
  ConsultationType,
  ConsultationValue
} from '../../../../models/consultation/consultation.model';
import { GroupWaitingModel } from '../../../../models/waiting-room/group-waiting.model';
import { IndividualWaitingModel } from '../../../../models/waiting-room/individual-waiting.model';
import 'rxjs/add/observable/of';
import { ConsultationUrl } from '../../../../shared/urls/consultation.url';
import { Utility } from '../../../../common/utility';

@Injectable()
export class GroupWaitingService {
  constructor(public baseService: BaseService) {}

    createGroupWaitting(param) {
        let url = ConsultationUrl.CREATE_GROUP_CONSULTATION;
        return this.baseService.postData(url, param);
    }

    updateGroupWaitting(id, param) {
        let url = ConsultationUrl.UPDATE_GROUP_CONSULTATION.replace('{id}', id);
        return this.baseService.update(url, param);
    }

    removeGroupWaitting(param) {
        let url = ConsultationUrl.DELETE_GROUP_CONSULTATION.replace('{id}', param);
        return this.baseService.delete(url);
    }

    getWaitingGroupList(param) {
        let url = ConsultationUrl.GET_LIST_GROUP_CONSULTATION;
        return this.baseService.getData(url, param);
        // return datagroup;
    }

    getPatientAddList() {
        let url = ConsultationUrl.GET_LIST_PATIENT_ADDTOGROUP;
        return this.baseService.getData(url);
        // return data;
    }

  getGroupDetail(param) {
    let url = ConsultationUrl.GET_GROUP_CONSULTATION.replace('{id}', param);
    return this.baseService.getData(url);
    // return groupDetail;
  }

  getGroupMemberList(groupId, param) {
      let url = ConsultationUrl.GET_GROUP_CONSULTATION_MEMBER_LIST.replace('{id}', groupId);
      return this.baseService.getData(url, param);
    //   return this.baseService.getData(url, param);
    // return data;
  }

  getDataPaymentTerm() {
    const url = ConsultationUrl.GET_PAYMENT_TERM;
     return this.baseService.getData(url);
  }

  addPatientToGroup(groupId, consultationId) {
    const url = Utility.stringFormat(ConsultationUrl.ADD_PATIENT_TO_GROUP, [groupId]);
    return this.baseService.update(url, consultationId);
  }

  removePatientFromGroup(patientId, groupId) {
    const url = ConsultationUrl.REMOVE_PATIENT_FROM_GROUP.replace('{patientId}', patientId)
                                                        .replace('{groupId}', groupId);
    return this.baseService.delete(url);
}

  /**
   * Add patient to patient table and remove this patient from patientArr
   *  @param addedPatientArr list table
   *  @param patientArr list add Patient
   */

  addPatientToTable(tableArr, patientArr) {
    for (let i = 0; i < tableArr.length; i++) {
      for (let j = 0; j < patientArr.length; j++) {
        if (tableArr[i].userId === patientArr[j].userId) {
          patientArr.splice(j, 1);
          j--;
        }
      }
    }
  }

  /**
   * Remove patient from patient table and add this patient back to patient list
   *  @param tableArr patient table
   *  @param patientArr list available Patient
   *  @param userId
   */

  removePatientFromTable(tableArr, patientArr, id) {
    for (let i = 0; i < tableArr.length; i++) {
      if (tableArr[i].userId === id) {
        patientArr.push(tableArr[i]);
        tableArr.splice(i, 1);
        break;
      }
    }
  }
}

// export const groupDetail: GroupWaitingModel = {
//   id: '1',
//   groupId: '1',
//   groupREF: 'HUNI',
//   groupName: 'Hung Group',
//   contact: 'Hung Vuong',
//   phone: '12345678',
//   address: 'Dubin',
//   email: 'hungvuong@abc.com',
//   description: 'family',
//   noOfPatients: 4,
//   status: ConsultationType.Consultation,
//   patientArr: [],
//  paymentTerm:[]
// };

// const datagroup: Array<GroupWaitingModel> = [
//   {
//     id: '1',
//     groupId: '1',
//     groupREF: 'HUNI',
//     groupName: 'Hung Group',
//     contact: 'Hung Vuong',
//     phone: '12345678',
//     address: 'Dubin',
//     email: 'hungvuong@abc.com',
//     description: 'family',
//     noOfPatients: 4,
//     status: ConsultationType.Consultation,
//     patientArr: [],
//     paymentTerm:[]
//   },
//   {
//     id: '2',
//     groupId: '2',
//     groupREF: 'THUUNI',
//     groupName: 'Thuan Group',
//     contact: 'Thuan Nguyen',
//     phone: '12345678',
//     address: 'HCM',
//     email: 'vietle@abc.com',
//     description: 'family',
//     noOfPatients: 7,
//     status: ConsultationType.InConsultation,
//     patientArr: [],
//     paymentTerm:[]
//   }
// ];

// const data: Array<IndividualWaitingModel> = [
//   {
//     id: '1',
//     patientREF: 'HUN10000HC',
//     userId: '1',
//     name: 'Hung Vuong',
//     dateOfBirth: 1413173580,
//     group: 'Individual',
//     clinic: 'FLU',
//     arrivalTime: 1477239180,
//     departTime: 1477239180,
//     accounts: 'Accounts',
//     status: ConsultationType.Consultation,
//     isInvoiceOverDue: false,
//     lastedStep: 2
//   },
//   {
//     id: '2',
//     patientREF: 'HUN10000HC',
//     userId: '2',
//     name: 'Hung Vuong',
//     dateOfBirth: 1413173580,
//     group: 'Individual',
//     clinic: 'FLU',
//     arrivalTime: 1477239180,
//     departTime: 1477239180,
//     accounts: 'Accounts',
//     status: ConsultationType.InConsultation,
//     isInvoiceOverDue: false,
//     lastedStep: 2
//   }
// ];

// const dataTable: Array<IndividualWaitingModel> = [
//   {
//     id: "1",
//     patientREF: "HUN10000HC",
//     userId: "1",
//     name: "Hung Vuong",
//     dateOfBirth: 1413173580,
//     group: "Individual",
//     clinic: "FLU",
//     arrivalTime: 1477239180,
//     departTime: 1477239180,
//     accounts: "Accounts",
//     status: ConsultationType.AdministerVaccine,
//     isInvoiceOverDue: false
//   },
//   {
//     id: "2",
//     patientREF: "HUN10000HC",
//     userId: "1",
//     name: "Hung Vuong",
//     dateOfBirth: 1413173580,
//     group: "Individual",
//     clinic: "FLU",
//     arrivalTime: 1477239180,
//     departTime: 1477239180,
//     accounts: "Accounts",
//     status: ConsultationType.AdministerVaccine,
//     isInvoiceOverDue: false
//   }
// ];

/* export const paymentTerm = [
    {
      id: 1,
      name: 'Group 15 day credit',
    } ,
    {
      id: 2,
      name: 'Group members paying individually',
    } ,
]; */



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/waiting-room/group/group.service.ts